export const getLastDigits = (num: string) => {
  return num.substring(num.length - 4);
};
